import React, { memo, useEffect } from "react";
import api, { useAsync } from "src/api";
import { setDangerousHtml } from "src/utils";
import { SPONSORED_ADS_PROVIDER_IDS } from "src/utils/constants";
import styles from "./style.css";
import resultSerpStyles from "../Search/ResultsSERP/style.css";
import Placeholder from "./components/Placeholder";
import { clickNotify, sendClientEvents } from "./trackers/trackers";
import { useStore } from "src/store";
import { Load } from "src/component-loader";
import YahooAds from "./components/YahooAds";
import YahooAdsV2 from "./components/YahooAdsV2";
import NoReferrerMessage from "./components/NoReferrerMessage";
import { getClass, parseQs } from "../../utils";
import { useTranslation } from "react-i18next";

const getPostbackConfig = (postbacks = []) => {
  const urlParams = new URLSearchParams(window.location.search);
  return postbacks[urlParams.get("spx")] || postbacks.find(postback => postback.default) || postbacks[0] || {};
};

let clickPostback;
let impressionEventSent;
const ctaStyles = [
  "LEFTCTA",
  "RIGHTCTA",
  "CARD_LAYOUT_WITH_CTA_TEXT",
  "SQAURED_CARD_LAYOUT_WITH_CTA",
  "NUMBEREDCARDSLAYOUTCTA",
  "CHEVRONCTA",
  "WRAPPEDNUMBEREDCARD"
];

const SponsoredApiAds = memo(
  ({
    dublicateResults,
    sponsoredSearchResults2ClientImpressionsURL,
    sponsoredSearchResults2AllParams,
    sponsoredSearchResults2OverridePostbackCheck,
    sponsoredSearchResults2OverrideRequestKeys,
    sponsoredSearchResults2OverridePostbackKeys,
    sponsoredSearchResults2PostbackURL,
    bingSponsoredStyle,
    sponsoredSearchResults2Style,
    searchParams,
    sponsoredSearchResults2ProductAds,
    targetWindow,
    ssr2Postbacks,
    overrideSplitConfiguration,
    sponsoredSearchResults2,
    sponsoredSearchResults2AdSlots,
    sponsoredSearchResults2AdUnitId,
    overrideSponsoredSearchResults2AdUnitId,
    sponsoredSearchResults2TestTraffic,
    sponsoredSearchResults2D2STraffic,
    ...props
  }) => {
    let data;
    let reqId;
    let bingApiAdsResults;
    const store = useStore();
    const { paginationEnabled, isSponsoredOnly } = props;
    const { source } = parseQs(window.location.search);
    const getSponsoredApiAds = useAsync(api.getSponsoredSearch, { cache: true });
    const styleName = sponsoredSearchResults2Style || "BASIC";
    const serpStyle = bingSponsoredStyle[sponsoredSearchResults2Style || "BASIC"]?.id || 10;
    const { t: translator } = useTranslation();
    const URL = store("apiURL")?.URL;
    const { country } = store("config");
    const captcha = store("googleRecaptcha");
    const isValidSource = source === "bingtrt" || source === "ys" || source === "n2s";
    const defaultSource = sponsoredSearchResults2D2STraffic != "false" ? "bingd2s" : null;

    searchParams.limit = sponsoredSearchResults2AdSlots ? sponsoredSearchResults2AdSlots : undefined;
    searchParams.adUnitId = sponsoredSearchResults2AdUnitId ? sponsoredSearchResults2AdUnitId : undefined;
    searchParams.overrideAdUnitId = overrideSponsoredSearchResults2AdUnitId ? overrideSponsoredSearchResults2AdUnitId : false;
    searchParams.trafficType = sponsoredSearchResults2TestTraffic ? sponsoredSearchResults2TestTraffic : false;
    searchParams.overrideSplitConfiguration = overrideSplitConfiguration || null;
    searchParams.displayCTA = ctaStyles.includes(styleName) ? true : null;
    searchParams.source = isValidSource ? source : defaultSource;

    const paginationParams = {
      paginationEnabled,
      isSponsoredOnly
    };

    let topAds = props.data?.topAds || [];
    let bottomAds = props.data?.bottomAds || [];
    let dataVal = searchParams?.bingOneCall ? { data: { ...props.data, ...{ ads: [...topAds, ...bottomAds] } } } : {};
    const googleCustomAdsParams = props.googleCustomAdsParams && JSON.parse(props.googleCustomAdsParams);
    if (searchParams?.bingOneCall) {
      bingApiAdsResults = dataVal;
    } else if (dublicateResults) {
      bingApiAdsResults = store("ssr2DuplicatedResult");
    } else if (googleCustomAdsParams && googleCustomAdsParams.sponsoredAdsProvider === SPONSORED_ADS_PROVIDER_IDS.GOOGLE.name) {
      data = { provider: SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id };
    } else {
      bingApiAdsResults = getSponsoredApiAds({
        ...searchParams,
        ...{ serpStyle },
        ...{ productAds: sponsoredSearchResults2ProductAds, productAdsRequested: sponsoredSearchResults2ProductAds ? "yes" : "no" },
        style_name: sponsoredSearchResults2Style,
        datetime: new Date().toISOString(),
        userLocalDatetime: new Date().toISOString()
      });
    }

    if (bingApiAdsResults && bingApiAdsResults.data) {
      data = bingApiAdsResults.data;
      reqId = bingApiAdsResults.data.reqId;
    } else if (dublicateResults) {
      data = store("ssr2DuplicatedResult");
      reqId = store("ssr2DuplicatedResult")?.reqId;
    }

    if (!dublicateResults) {
      const sponsoredSearchResultStored = store("ssr2DuplicatedResult");
      if (!sponsoredSearchResultStored && data && data.ads?.length > 0 && data?.provider !== SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id) {
        store.set("ssr2DuplicatedResult", data);
      }
    }

    const productAdsData = data?.productAds || data?.content?.find(item => item.name === "productAds")?.value?.items;

    const postbackConfig = getPostbackConfig(ssr2Postbacks);

    useEffect(() => {
      window.addEventListener("pageshow", e => {
        if (e.persisted) {
          clickPostback = false;
        }
      });
    }, []);

    useEffect(() => {
      if (
        data &&
        data.ads &&
        data.ads.length &&
        data.provider !== SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id &&
        !impressionEventSent &&
        window.fbq &&
        postbackConfig.type === "facebookPixel" &&
        postbackConfig.impressionEvent
      ) {
        // window.fbq("track", postbackConfig.impressionEvent);
        const urlParams = new URLSearchParams(window.location.href);
        const impressionData = {};
        let eventId = null;

        if (!eventId && postbackConfig?.customImpressionData) {
          try {
            const customData = JSON.parse(postbackConfig.customImpressionData);
            if (customData.event_id) {
              eventId = customData.event_id;
            }
            Object.entries(customData).forEach(([key, val]) => {
              if (key !== 'event_id' && !Object.prototype.hasOwnProperty.call(impressionData, key)) {
                impressionData[key] = val;
              }
            });
          } catch (e) {
            console.error('Invalid JSON in customImpressionData', e);
          }
        }
        // Override all 'cx_' parameters from URL
        urlParams.forEach((value, key) => {
          if (key.startsWith('cx_')) {
            if (key === 'cx_event_id') {
              eventId = value;
            } else {
              impressionData[key.replace(/^cx_/, '')] = value;
            }
          }
        });

        // Fire fbq event
        if (Object.keys(impressionData).length > 0 || eventId) {
          if (eventId) {
            window.fbq("track", postbackConfig.impressionEvent, impressionData, { eventID: eventId });
          } else {
            window.fbq("track", postbackConfig.impressionEvent, impressionData);
          }
        } else {
          window.fbq("track", postbackConfig.impressionEvent);
        }
        store.set("loadedAds", { haveAdsLoaded: true });
        impressionEventSent = true;
      }
    }, [data]);

    let templateStyle = (bingSponsoredStyle && bingSponsoredStyle["BASIC"]?.style) || "";
    if (bingSponsoredStyle && bingSponsoredStyle[sponsoredSearchResults2Style.toUpperCase()] && sponsoredSearchResults2Style !== "BASIC") {
      templateStyle += bingSponsoredStyle[sponsoredSearchResults2Style.toUpperCase()]?.style || "";
    }

    const sendClientEventsExtraParams = {
      searchParams,
      sponsoredSearchResults2Style,
      sponsoredSearchResults2AllParams,
      sponsoredSearchResults2OverridePostbackCheck,
      sponsoredSearchResults2OverrideRequestKeys,
      sponsoredSearchResults2OverridePostbackKeys,
      sponsoredSearchResults2ClientImpressionsURL,
      sponsoredSearchResults2PostbackURL,
      postbackConfig
    };

    const clickNotifyExtraParams = {
      ...sendClientEventsExtraParams,
      sponsoredSearchResults2ProductAds,
      dublicateResults,
      URL,
      country,
      clickPostback,
      targetWindow,
      captcha
    };

    if (templateStyle) {
      const stylesWithDot = ["CHEVRONCTA", "WRAPPEDNUMBEREDCARD", "WEBSITEFIRST"];
      const ssr2Style = sponsoredSearchResults2Style.toUpperCase();
      const withDot = stylesWithDot.includes(ssr2Style);
      let adReplacement = translator("Search.Ad");
      templateStyle = templateStyle.split(withDot ? "'Ad.'" : "'Ad'").join("'" + adReplacement + "'");
      templateStyle = templateStyle.split(withDot ? '"Ad."' : '"Ad"').join('"' + adReplacement + '"');
    }

    if (bingApiAdsResults?.loading) {
      return <Placeholder />;
    } else if (data) {
      const { provider } = data;
      const gsceBQData = {
        reqId,
        searchParams,
        URL,
        country
      };
      switch (provider) {
        case SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id:
          return (
            <Load
              name="sponsoredGcse"
              googleCustomAdsParams={props.googleCustomAdsParams}
              gsceBQData={gsceBQData}
              clickData={{ data, clickNotifyExtraParams, reqId }}
              sendClientEventsExtraParams={sendClientEventsExtraParams}
            />
          );
        case SPONSORED_ADS_PROVIDER_IDS.YAHOO_SYNDICATION.id || SPONSORED_ADS_PROVIDER_IDS.BING.id:
          if (data.noReferrer) {
            return <NoReferrerMessage />;
          }
          if (data.ads && data.ads.length > 0 && !data?.useYahooV2) {
            return (
              <div className={getClass(styles.container, resultSerpStyles.container)}>
                <style ref={setDangerousHtml(templateStyle)}></style>
                <header style={{ paddingLeft: "1rem", color: "#aaa" }}>
                  {translator("Search.Sponsored Results for")}
                  <strong>{searchParams && searchParams.activeSearchedTerm}</strong>
                </header>
                <YahooAds
                  translator={translator}
                  URL={URL}
                  reqId={reqId}
                  country={country}
                  adsAPI={bingApiAdsResults}
                  overrideOrganicStyles={{
                    titleColor: props[`ssr3${sponsoredSearchResults2Style}TitleFontColor`],
                    titleFontSize: props[`ssr3${sponsoredSearchResults2Style}TitleFontSize`],
                    siteColor: props[`ssr3${sponsoredSearchResults2Style}SiteFontColor`],
                    siteFontSize: props[`ssr3${sponsoredSearchResults2Style}SiteFontSize`],
                    descriptionColor: props[`ssr3${sponsoredSearchResults2Style}DescriptionFontColor`],
                    descriptionFontSize: props[`ssr3${sponsoredSearchResults2Style}DescriptionFontSize`]
                  }}
                  searchParams={searchParams}
                  data={{ ...data, productAds: productAdsData }}
                  activeSearchedTerm={searchParams.activeSearchedTerm}
                  sponsoredSearchResults2ClientImpressionsURL={sponsoredSearchResults2ClientImpressionsURL}
                  otherParams={{ targetWindow: props.targetWindow, contentType: props.contentType, variant: props.variant }}
                  clickNotify={(item, index, data) => clickNotify(item, index, data, clickNotifyExtraParams, reqId)}
                  sendClientEvents={(item, type, index) => sendClientEvents(item, type, index, sendClientEventsExtraParams)}
                  dublicateResults={dublicateResults}
                  loading={bingApiAdsResults?.loading}
                  paginationParams={paginationParams}
                  sponsoredSearchResults2Style={sponsoredSearchResults2Style}
                  requestParams={searchParams}
                  sponsoredSearchResults2={sponsoredSearchResults2}
                  articlePage={props.articlePage}
                />
              </div>
            );
          } else if (data.statusDescription && !data.useYahooV2) {
            return <div>{data.statusDescription}</div>;
          }

          if (data.ads && data.useYahooV2) {
            return (
              <div className={getClass(styles.container, resultSerpStyles.container)}>
                <style ref={setDangerousHtml(templateStyle)}></style>
                <header style={{ paddingLeft: "1rem", color: "#aaa" }}>
                  {data.ads.length > 0 ? (
                    <>
                      {translator("Search.Sponsored Results for")}
                      <strong>{searchParams && searchParams.activeSearchedTerm}</strong>
                    </>
                  ) : (
                    data.statusDescription
                  )}
                </header>
                <YahooAdsV2
                  translator={translator}
                  URL={URL}
                  reqId={reqId}
                  country={country}
                  adsAPI={bingApiAdsResults}
                  overrideOrganicStyles={{
                    titleColor: props[`ssr3${sponsoredSearchResults2Style}TitleFontColor`],
                    titleFontSize: props[`ssr3${sponsoredSearchResults2Style}TitleFontSize`],
                    siteColor: props[`ssr3${sponsoredSearchResults2Style}SiteFontColor`],
                    siteFontSize: props[`ssr3${sponsoredSearchResults2Style}SiteFontSize`],
                    descriptionColor: props[`ssr3${sponsoredSearchResults2Style}DescriptionFontColor`],
                    descriptionFontSize: props[`ssr3${sponsoredSearchResults2Style}DescriptionFontSize`]
                  }}
                  searchParams={searchParams}
                  data={{ ...data, productAds: productAdsData }}
                  activeSearchedTerm={searchParams.activeSearchedTerm}
                  sponsoredSearchResults2ClientImpressionsURL={sponsoredSearchResults2ClientImpressionsURL}
                  otherParams={{ targetWindow: props.targetWindow, contentType: props.contentType, variant: props.variant }}
                  clickNotify={(item, index, data) => clickNotify(item, index, data, clickNotifyExtraParams, reqId)}
                  sendClientEvents={(item, type, index) => sendClientEvents(item, type, index, sendClientEventsExtraParams)}
                  dublicateResults={dublicateResults}
                  loading={bingApiAdsResults?.loading}
                  paginationParams={paginationParams}
                  sponsoredSearchResults2Style={sponsoredSearchResults2Style}
                  requestParams={searchParams}
                  sponsoredSearchResults2={sponsoredSearchResults2}
                  articlePage={props.articlePage}
                />
              </div>
            );
          }
      }
    }
  }
);

export default SponsoredApiAds;
